import {
  ExpandMoreOutlined,
  KeyboardBackspaceOutlined,
  EditOutlined,
  DeleteOutline,
  AddCircleOutlineOutlined,
} from "@mui/icons-material";
import {
  Typography,
  Button,
  Grid,
  Card,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
} from "@mui/material";
import { MatxLoading } from "app/components";
import {
  deletePublish,
  getUserPublishes,
} from "app/services/publishServices/Publish";
import React, { useEffect, useState } from "react";
import FormPublish from "./FormPublish";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";

export type Publish = UserPublish[];

export interface UserPublish {
  id: number;
  user_id: number;
  publish_id: number;
  active: number;
  created_at: string;
  updated_at: any;
  publish: PublishDetails;
}

export interface PublishDetails {
  id: number;
  authors: string;
  title: string;
  journal: string;
  year: number;
  doi: string;
  created_by: number;
  created_at: string;
  updated_at: string;
}

const PublishInfo = ({ publish, setEditPublish, deletePublish, deleting }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreOutlined />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" display="block">
            {publish.title}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary" display="block">
            {publish.authors} - {publish.journal} ({publish.year})
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Typography variant="subtitle2" color="textSecondary">
              Autores:
            </Typography>
            <Typography variant="body1">{publish.authors}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle2" color="textSecondary">
              Journal/Periódico:
            </Typography>
            <Typography variant="body1">{publish.journal}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle2" color="textSecondary">
              Ano:
            </Typography>
            <Typography variant="body1">{publish.year}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle2" color="textSecondary">
              DOI:
            </Typography>
            <Typography variant="body1">{publish.doi}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => setEditPublish(publish)}
            >
              <EditOutlined /> &nbsp; Editar Publicação
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
            <LoadingButton
              loading={deleting}
              variant="contained"
              size="small"
              color="error"
              onClick={() => deletePublish(publish.id)}
            >
              <DeleteOutline /> &nbsp; Excluir Publicação
            </LoadingButton>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

const ListPublish = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [publishData, setPublishData] = useState<UserPublish[]>([]);
  const [newPublish, setNewPublish] = useState<boolean>(false);
  const [editPublish, setEditPublish] = useState<any>();
  const [deleting, setDeleting] = useState<boolean>(false);

  const loadPublishList = async () => {
    const request: any = await getUserPublishes();
    const data = request.data.response;
    setPublishData(data);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    loadPublishList();
  }, [editPublish, newPublish]);

  const deletePublishAction = async (id: number) => {
    setDeleting(true);
    Swal.fire({
      title: `Deseja excluir a publicação selecionada?`,
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancelar e manter",
      confirmButtonText: "Excluir",
      confirmButtonColor: "red",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const deleteRequest = await deletePublish(id as number); // eslint-disable-line
        } catch (e: any) {
          Swal.showValidationMessage(`${e.response.data.response}`);
        } finally {
          setDeleting(false);
          loadPublishList();
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Publicação Excluída com Sucesso",
          icon: "success",
        });
      }
      setDeleting(false);
    });
  };

  if (loading) {
    return (
      <div style={{ height: "10vh" }}>
        <MatxLoading />
      </div>
    );
  }

  if (!newPublish && !editPublish) {
    return (
      <Card>
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              justifyContent="space-between"
              alignItems="center"
              paddingLeft={1}
              paddingTop={1}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  marginBottom: 1,
                  fontWeight: 600,
                  color: "#1a237e",
                  letterSpacing: "-0.5px",
                }}
              >
                Cadastro de Publicações
                <Typography
                  variant="body1"
                  sx={{ marginBottom: 3, color: "#000" }}
                >
                  Cadastre todos as publicações que possui participação.
                </Typography>
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setNewPublish(true)}
                startIcon={<AddCircleOutlineOutlined fontSize="small" />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  px: 2,
                  py: 1,
                  boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(25, 118, 210, 0.3)",
                  },
                }}
              >
                Cadastrar
              </Button>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              {publishData.map((publish) => (
                <PublishInfo
                  key={publish.id}
                  publish={publish}
                  setEditPublish={setEditPublish}
                  deletePublish={deletePublishAction}
                  deleting={deleting}
                />
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  if (newPublish) {
    return (
      <Card>
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              justifyContent="space-between"
              alignItems="center"
              paddingLeft={1}
              paddingTop={1}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  marginBottom: 1,
                  fontWeight: 600,
                  color: "#1a237e",
                  letterSpacing: "-0.5px",
                }}
              >
                Cadastrar nova Publicação
                <Typography
                  variant="body1"
                  sx={{ marginBottom: 3, color: "#000" }}
                >
                  Preencha todas as informações necessárias.
                </Typography>
              </Typography>
              <Button
                variant="text"
                color="primary"
                size="small"
                onClick={() => setNewPublish(false)}
              >
                <KeyboardBackspaceOutlined />
                &nbsp; Voltar
              </Button>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <FormPublish setNewPublish={setNewPublish} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  if (editPublish) {
    return (
      <Card>
        <CardContent>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h5">Editar Publicação</Typography>
              <Button
                variant="text"
                color="primary"
                size="small"
                onClick={() => setEditPublish(null)}
              >
                <KeyboardBackspaceOutlined />
                &nbsp; Voltar
              </Button>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <FormPublish data={editPublish} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  return (
    <div style={{ height: "10vh", textAlign: "center" }}>
      <Typography variant="h6"> Falha ao Renderizar a página </Typography>
    </div>
  );
};

export default ListPublish;
